const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.header-cart-count', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
  table_header_ajax: '.table_header_ajax',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelectorAll(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const table_header_ajax = document.querySelector(defaults.table_header_ajax);

const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {

  addToCart[i].addEventListener('click', function(event) {
    
    event.preventDefault();
    const formID = this.parentNode.parentNode.parentNode.getAttribute('id');


    //console.log(this.parentNode.parentNode.parentNode, 'test');



    addProductToCart(formID);

  });

}

function addProductToCart(formID) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail,
  });
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);

      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = 'Your cart is empty. No bueno.';
        $('#shipping-offer').hide();
      } else {
        renderCart(cart);
        checkoutButton.classList.remove('is-hidden');
      }
    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
      }
    },
  });
}

function onCartUpdate(cart) {
  //console.log('items in the cart?', cart.item_count);

  if(cart.item_count == 0) {
    table_header_ajax.classList.add('hidden_item');
  }
  else {
    table_header_ajax.classList.remove('hidden_item');
  }
  cartCounter.innerHTML = cart.item_count;

}

function addToCartOk(product) {
  cartModalContent.innerHTML = product.title + ' was added to the cart!';
  //     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  //     openAddModal();
  openCartDrawer();

  openCartOverlay();
  fetchCart();
}

function removeProductFromCart() {
  cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  openAddModal();
  openCartOverlay();
}


function isCheckoutValid() {
  var tags = $('.cart-item-tags').map(function() {
    return $(this).text();
  }).get();

  var valid = false;
  var tagsJoin = tags.join(',').split(',');
  var ctag = $('.ctag').text().split(',');
  var common = $.grep(tagsJoin, function(element) {
    return $.inArray(element, ctag ) !== -1;
  });


  var hasTag = false;
  if( common.length > 0) {
    hasTag = true;
  };

  var sum = 0;
  $('.bypass_cart__true').each(function(){
    sum += parseFloat($(this).text());
  });
  if( sum > 3 || hasTag) {
    $('.js-ajax-checkout-button').removeClass('disable_link');
  }
  //console.log(hasTag, sum > 1, 'tender true');

}

function isIcecream(item) {
  var isIcecream = false;
  if( item.product_type == 'Fine Ice Creams') {
    isIcecream = true;
  };
  return isIcecream;
}




function renderCart(cart) {

  //console.log(cart);

  clearCartDrawer();

  var chkqty = 0;
  var isIceCreamExists = false;
  var uu='';
  //console.log(cart)
  cart.items.forEach(function(item, index) {

    uu += item.variant_id+':'+item.quantity+','; 

    const productImage = '<div class="ajax-cart-item"><img class="ajax-cart-item__image" src="' + item.image + '" >';
    const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div></div>';
    const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.price ) + '</div>';
    const productQuantity = '<div class="ajax-cart-item__quantity bypass_cart__' + isIcecream(item) +'">' + item.quantity + '</div>';
    const productTotalPrice = '<div class="ajax-cart-item__totalprice">' + Shopify.formatMoney(item.line_price)  + '</div>';


    const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"></div>';

    const concatProductInfo = '<div class="ajax-cart-item__single cart-item" data-line="' + Number(index + 1) + '">' + productImage + productTitle + productPrice + productQuantity + productTotalPrice + productRemove + '</div>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

    if(isIcecream(item)){
      chkqty += parseInt(item.quantity);
      $('.cartBoxOffer').show();
      isIceCreamExists = true;
    }

  });
  //console.log(uu)
  //console.log("qty:"+chkqty);
	
  if(isIceCreamExists){
    if(parseInt(chkqty) > 3){
      $('.js-ajax-checkout-button').attr('href','/cart/'+uu.replace(/(^,)|(,$)/g, ""));
      $('.js-ajax-checkout-button').css("opacity","1");
      $('.js-ajax-checkout-button').removeClass('disable_link_2');
      $('.incompleted').hide();          
      $('.completed').show();
    }else{
      $('.js-ajax-checkout-button').addClass('disable_link_2');
      $('.js-ajax-checkout-button').css("opacity","0.2");
      $('.js-ajax-checkout-button').attr('href','javascript:void(0);');    
      $('.incompleted .circle').text(4-parseInt(chkqty));
      $('.incompleted').show();       
      $('.completed').hide();
    }
  }else{
  	  $('.js-ajax-checkout-button').attr('href','/cart/'+uu.replace(/(^,)|(,$)/g, ""));
      $('.js-ajax-checkout-button').css("opacity","1");
      $('.js-ajax-checkout-button').removeClass('disable_link_2');
      $('.incompleted').hide();          
      $('.completed').hide();
  }
  

  
  
  const cartTotalPrice = '<div class="ajax-cart-total"><span>Total:</span>' + Shopify.formatMoney(cart.total_price) + '</div>';
  cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + cartTotalPrice;
  
  var targetAmount = 100*100;
  var restAmount = (parseFloat(targetAmount) - parseFloat(cart.total_price));
  var percentageShow = 100-(parseFloat(restAmount)/parseFloat(targetAmount)*100);
  if(percentageShow>100){
  	percentageShow = 100;
  }
  
  var shippingText = "You are "+Shopify.formatMoney(restAmount)+" away from free shipping";
  
  if(restAmount <= 0){
  	shippingText = "Free shipping applied";
  }
  
  $('#shipping-offer').find('.text').html(shippingText);
  $('#shipping-offer').find('.percentage_container').find('.percentage').css("width", percentageShow+'%');
  
  $('#shipping-offer').show();
  
  
  
  //$('#shipping-offer').html(shippingText);



  removeFromCart = document.querySelectorAll(defaults.removeFromCart);

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function() {
      const line = this.parentNode.getAttribute('data-line');
      //console.log(line);
      changeItem(line);
    });
  }

}

function openCartDrawer() {
  cartDrawer.classList.add('is-open');


}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openAddModal() {
  cartModal.classList.add('is-open');
}

function closeAddModal() {
  cartModal.classList.remove('is-open');
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
  closeAddModal();
  closeCartOverlay();
});


cartDrawerClose.forEach(item => {
  item.addEventListener('click', event => {
    closeCartDrawer();
    closeCartOverlay();
  })
})


// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function(event) {
  event.preventDefault();
  //fetchCart();
  openCartDrawer();
  openCartOverlay();
  isCheckoutValid();

});

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
});